import type { RouterConfig } from '@nuxt/schema'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

// https://router.vuejs.org/api/#routeroptions
export default <RouterConfig>{
  scrollBehavior: async (to: RouteLocationNormalizedGeneric) => {
    if (!document) {
      return
    }

    if (!window) {
      return
    }

    if (true === to.meta?.ignoreScroll) {
      return
    }

    if (!to.hash) {
      return {
        top: 0,
        left: 0,
      }
    }

    const hash = to.hash.substring(1)
    const headerHeight = document.querySelector<HTMLElement>('.header')?.offsetHeight || 0
    const teamHeaderHeight = document.querySelector<HTMLElement>('.team-header')?.offsetHeight || 0
    const offset = headerHeight || teamHeaderHeight
    const elementToScroll = document.getElementById(hash)

    if (!elementToScroll) {
      return
    }

    const elementPosition = elementToScroll.getBoundingClientRect().top || 0
    const offsetPosition = elementPosition + window.scrollY - offset

    return {
      behavior: 'smooth',
      top: offsetPosition,
    }
  },
}
